import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOffScheduleUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.62988 18.36C8.50988 21.25 12.9599 21.84 16.4899 19.8C20.0199 17.77 21.7399 13.61 20.6899 9.67999C19.6399 5.73999 16.0699 3.01001 11.9999 3.01001",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.78018 15.43C3.78018 15.43 3.76018 15.48 3.73018 15.48C3.70018 15.48 3.68018 15.46 3.68018 15.43C3.68018 15.4 3.70018 15.38 3.73018 15.38C3.74018 15.38 3.76019 15.38 3.77019 15.39C3.77019 15.39 3.78018 15.41 3.78018 15.43",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.10001 11.9999C3.10001 11.9999 3.08 12.0499 3.05 12.0499C3.02 12.0499 3 12.0299 3 11.9999C3 11.9699 3.02 11.95 3.05 11.95C3.06 11.95 3.08 11.9499 3.09 11.9599C3.09 11.9599 3.10001 11.9799 3.10001 11.9999",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.78018 8.58002C3.78018 8.58002 3.76018 8.63004 3.73018 8.63004C3.70018 8.63004 3.68018 8.61002 3.68018 8.58002C3.68018 8.55002 3.70018 8.53003 3.73018 8.53003C3.74018 8.53003 3.76019 8.53004 3.77019 8.54004C3.77019 8.54004 3.78018 8.56002 3.78018 8.58002",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.72012 5.67001C5.72012 5.67001 5.70012 5.72 5.67012 5.72C5.64012 5.72 5.62012 5.70001 5.62012 5.67001C5.62012 5.64001 5.64012 5.62 5.67012 5.62C5.68012 5.62 5.70013 5.62 5.71013 5.63C5.71013 5.63 5.72012 5.65001 5.72012 5.67001",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.62001 3.72995C8.62001 3.72995 8.60002 3.77994 8.57002 3.77994C8.54002 3.77994 8.52002 3.75995 8.52002 3.72995C8.52002 3.69995 8.54002 3.67993 8.57002 3.67993C8.58002 3.67993 8.60002 3.67994 8.61002 3.68994C8.61002 3.68994 8.62001 3.70995 8.62001 3.72995",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9497 16.3622L11.9497 8.36218",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 11.7725L11.67 8.1125C11.82 7.9625 12.07 7.9625 12.23 8.1125L15.9 11.7725",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgOffScheduleUp;
